import React from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../../utils/constants";
import { AppIconProps } from "./types";

const AppIcon = ({ appName, appNameStyle }: AppIconProps) => {
  return (
    <Link to="/" className="flex items-center gap-3">
      <div
        className={
          "w-10 h-10 rounded-xl bg-[#3BA2F4] overflow-hidden flex items-center justify-center"
        }
      >
        <svg
          width="1024"
          height="1024"
          viewBox="0 0 1024 1024"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="1024" height="1024" fill="#3BA2F4" />
          <g clip-path="url(#clip0_36_2)">
            <mask
              id="mask0_36_2"
              maskUnits="userSpaceOnUse"
              x="262"
              y="177"
              width="500"
              height="670"
            >
              <path d="M762 177H262V846.245H762V177Z" fill="white" />
            </mask>
            <g mask="url(#mask0_36_2)">
              <path
                d="M514.189 810.755C635.051 810.755 733.03 712.752 733.03 591.859C733.03 470.966 635.051 372.963 514.189 372.963C393.326 372.963 295.347 470.966 295.347 591.859C295.347 712.752 393.326 810.755 514.189 810.755Z"
                fill="white"
              />
              <path
                d="M520.258 231.27V318.828H534.847C537.882 318.828 545.627 321.897 548.353 323.664C558.09 329.994 561.183 340.226 563.601 350.941C662.392 371.396 742.058 454.11 758.45 553.809C794.854 775.249 543.576 930.725 362.767 796.154C197.782 673.373 243.801 415.576 439.591 356.136C443.076 355.077 458.857 351.992 460.25 350.949C461.358 350.107 462.425 342.019 463.193 339.717C466.894 328.676 478.741 318.836 490.67 318.836H503.592V231.278C476.298 223.048 478.449 181.987 506.886 177.451C541.775 171.88 552.546 220.304 520.266 231.278L520.258 231.27ZM499.241 397.464C352.396 406.311 265.885 569.461 341.183 696.838C415.156 821.973 594.322 827.182 676.006 706.861C768.679 570.362 662.992 387.607 499.249 397.472L499.241 397.464Z"
                fill="#012441"
              />
              <path
                d="M520.433 575.498C526.761 578.408 531.121 583.095 533.23 589.791C533.864 591.801 532.913 594.42 534.931 595.596L597.549 618.851C604.635 622.777 601.3 635.406 592.572 634.697L529.612 611.662C526.419 611.262 523.776 615.017 520.492 616.351C493.364 627.433 477.09 587.039 503.61 575.114V456.886C506.052 448.697 515.215 447.296 519.616 454.968C521.192 494.969 519.608 535.371 520.417 575.498H520.433Z"
                fill="#010101"
              />
              <path
                d="M400.875 540.058C448.745 535.188 454.847 606.111 409.712 611.437C360.892 617.201 353.814 544.853 400.875 540.058ZM411.638 552.499C407.661 553.4 404.518 558.895 404.318 562.722C403.56 577.299 423.326 578.558 426.519 568.21C429.712 557.861 422.009 550.139 411.638 552.499Z"
                fill="#010101"
              />
              <path
                d="M615.114 540.041C663.426 534.971 668.653 607.586 623.209 611.512C574.155 615.751 568.795 544.911 615.114 540.041ZM628.411 551.674C616.515 552.733 614.197 572.029 626.744 574.639C645.61 578.566 645.593 550.148 628.411 551.674Z"
                fill="#010101"
              />
              <path
                d="M486.678 635.047C492.488 633.322 492.93 638.431 495.648 641.565C503.576 650.705 518.458 651.605 526.969 642.837C529.912 639.798 532.505 631.575 538.249 635.656C545.318 640.665 532.672 652.097 528.02 654.727C515.014 662.079 497.182 659.62 487.728 647.821C485.177 644.637 480.442 636.898 486.678 635.047Z"
                fill="#010101"
              />
              <path
                d="M509.179 752.635C512.755 751.818 516.957 752.51 518.941 755.852C520.717 758.845 520.792 770.768 520.067 774.357C518.207 783.547 504.927 782.721 503.635 774.498C502.726 768.718 501.976 754.277 509.179 752.626V752.635Z"
                fill="#010101"
              />
              <path
                d="M510.896 410.705C513.847 410.33 518.515 413.032 519.624 415.775C520.641 418.294 520.717 431.236 519.883 433.954C517.423 441.934 504.76 441.909 503.559 431.844C502.759 425.123 502.034 411.839 510.888 410.705H510.896Z"
                fill="#010101"
              />
              <path
                d="M673.413 586.69C676.281 586.047 690.113 586.139 692.613 587.148C699 589.708 698.392 601.101 690.696 602.31C687.721 602.777 674.556 602.735 672.196 601.726C666.377 599.247 666.986 588.115 673.413 586.69Z"
                fill="#010101"
              />
              <path
                d="M332.438 586.69C337.658 585.522 352.822 585.063 354.815 591.468C358.741 604.102 341.943 603.318 333.914 602.377C324.635 601.285 324.71 588.424 332.438 586.69Z"
                fill="#010101"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_36_2">
              <rect
                width="500"
                height="669.245"
                fill="white"
                transform="translate(262 177)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <span
        className={appNameStyle ?? "text-white font-heading font-bold text-xl"}
      >
        {appName ?? APP_NAME}
      </span>
    </Link>
  );
};

export default AppIcon;
